import { useRef, useState } from "react";

export const SpotlightCard = ({ children, className = "", ...props }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: -600, y: -600 });

  const onMouseMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    setPos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
  };

  return (
    <div
      ref={ref}
      onMouseMove={onMouseMove}
      onMouseLeave={() => setPos({ x: -600, y: -600 })}
      className={`relative ${className}`}
      {...props}
    >
      <div
        className="pointer-events-none absolute inset-0 z-10"
        style={{
          background: `radial-gradient(520px circle at ${pos.x}px ${pos.y}px, rgba(0,229,255,0.09), transparent 45%)`,
        }}
      />
      {children}
    </div>
  );
};
